__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "reviews";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@xto10x/core/lib/analytics", "0.37.0", function() { return Promise.all([__webpack_require__.e("vendors-node_modules_sentry_browser_cjs_index_js-node_modules_xto10x_core_lib_networkUtils_js-a108ed"), __webpack_require__.e("vendors-node_modules_xto10x_core_lib_analytics_adapters_ga4_js-node_modules_xto10x_core_lib_a-8aefae"), __webpack_require__.e("node_modules_xto10x_core_lib_analytics_adapters_sync_recursive_-_45980")]).then(function() { return function() { return __webpack_require__(/*! ./node_modules/@xto10x/core/lib/analytics/index.js */ "./node_modules/@xto10x/core/lib/analytics/index.js"); }; }); });
			register("react-dom", "16.13.1", function() { return function() { return __webpack_require__(/*! ./node_modules/react-dom/index.js */ "./node_modules/react-dom/index.js"); }; }, 1);
			register("react-dom", "16.14.0", function() { return function() { return __webpack_require__(/*! ./node_modules/@peoplecues/commons/node_modules/react-dom/index.js */ "./node_modules/@peoplecues/commons/node_modules/react-dom/index.js"); }; }, 1);
			register("react", "16.13.1", function() { return function() { return __webpack_require__(/*! ./node_modules/react/index.js */ "./node_modules/react/index.js"); }; }, 1);
			register("react", "16.14.0", function() { return function() { return __webpack_require__(/*! ./node_modules/@peoplecues/commons/node_modules/react/index.js */ "./node_modules/@peoplecues/commons/node_modules/react/index.js"); }; }, 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};